import { Fragment } from 'react';
import { STRATUM_BG, useMetaContext } from '../base';
import type { GeoChartColumn, GeoData } from '../types';

export const StratumGeoChartBodyColumn = ({ column, geoData }: { column: GeoChartColumn; geoData: GeoData }) => {
    const meta = useMetaContext();
    const stratums: Array<{ name: string; y1: number; y2: number }> = [];

    if (geoData) {
        for (const stratum of geoData.stratums) {
            const y1 = meta.depths.depthToPixelsY(stratum.start);
            const y2 = meta.depths.depthToPixelsY(stratum.end);

            stratums.push({
                name: stratum.name,
                y1,
                y2,
            });
        }
    }

    return (
        <div style={{ width: column.width, height: meta.content.height }} className="relative">
            {stratums.map(({ y1, y2, name }, dIndex) => {
                return (
                    <Fragment key={dIndex}>
                        <div
                            style={{
                                top: Math.min(y1, y2),
                                height: Math.abs(y2 - y1),
                                backgroundColor: STRATUM_BG,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            className="absolute w-full border-b border-t"
                        >
                            <div
                                style={{
                                    writingMode: 'vertical-lr',
                                    transform: 'rotate(180deg)',
                                    textAlign: 'right',
                                }}
                                className="flex justify-center items-center h-full w-full py-auto"
                            >
                                {name}
                            </div>
                            <div style={{ flexGrow: 1 }}></div> {/* Filler space for the main content */}
                        </div>
                    </Fragment>
                );
            })}
        </div>
    );
};
